import { getRequiredFields } from "components/form/utils";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { taskSchema } from "./schema";
import { useCreateTask } from "../create/mutation";
import { fileUpload } from "directus/src/operations";

export const useTaskForm = () => {
  const createTaskMutation = useCreateTask();
  const navigate = useNavigate();

  const form = useForm({
    resolver: zodResolver(taskSchema),
    defaultValues: {
      title: "",
      description: "",
      status: "open",
      assignee: null,
      attachments: [],
      due_date: null,
    },
  });

  const requiredFields = useMemo(
    () => getRequiredFields(taskSchema),
    [taskSchema]
  );

  const handleCreate = async (context) => {
    const values = context.values;

    let attachmentIds = [];
    if (Array.isArray(values.attachments) && values.attachments.length > 0) {
      const newFiles = values.attachments.filter((f) => f.isNew && f.file);
      const existingFiles = values.attachments.filter((f) => !f.isNew && f.id);

      const uploadedFiles = [];
      for (const fileObj of newFiles) {
        try {
          const formData = new FormData();
          formData.append("file", fileObj.file);
          const uploaded = await fileUpload(formData);
          uploadedFiles.push(uploaded.id);
        } catch (error) {
          console.error("File upload failed:", error);
        }
      }

      attachmentIds = [...existingFiles.map((f) => f.id), ...uploadedFiles];
    }

    // tasks_attachments junction uses `file` (not `attachment` like tickets)
    const transformedValues = {
      ...values,
      attachments: attachmentIds.map((id) => ({ file: id })),
    };

    const response = await createTaskMutation.mutateAsync({
      values: transformedValues,
    });

    navigate(`/tasks/assigned-by-me/${response.id}`);
  };

  return {
    form,
    requiredFields,
    handleCreate,
  };
};
